<template>
  <div>
    <TicketFilter
      :ticket-type="ticketType"
      :search-incident.sync="filter.searchIncident"
      :search-priority.sync="filter.searchPriority"
      :search-status.sync="filter.caseStatus"
      :search-customer-name.sync="filter.searchCustomerName"
      :search-phone-number.sync="filter.searchPhoneNumber"
      :search-ticket-id.sync="filter.searchTicketId"
      :search-subject.sync="filter.searchSubject"
      :search-user-group.sync="filter.searchUserGroup"
      :user-group="userGroup"
      :start-date.sync="filter.startDate"
      :end-date.sync="filter.endDate"
      @fetch-filter="fetchFilter()" />
    <b-card class="mt-2">
      <TableTop
        v-model="pagination.limit"
        label="Open Case Tab"
        to-path="/case/add"
        @input="fetchFilter()" />
      <div class="zoom-80">
        <b-table
          striped
          hover
          responsive
          :items="items"
          :fields="fields"
          @row-clicked="rowClick($event)">
          <template #cell(incidentType)="data">
            <div v-if="data.item.tickeType && data.item.tickeType.name">
              {{ data.item.tickeType.name }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(createdAt)="data">
            <div v-if="data.item.createdAt">
              {{ data.item.createdAt | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(updatedAt)="data">
            <div v-if="data.item.updatedAt">
              {{ data.item.updatedAt | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(createdBy)="data">
            <div v-if="data.item && data.item.createdBy ">
              {{ data.item.createdBy.username }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(progressBy)="data">
            <div v-if="data.item && data.item.progressBy.firstName && data.item.progressBy.lastName ">
              {{ data.item.progressBy.firstName }} {{ data.item.progressBy.lastName }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(dueDate)="data">
            <div v-if="data.item.dueDate">
              {{ data.item.dueDate | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(resolveDate)="data">
            <div v-if="data.item.resolveDate">
              {{ data.item.resolveDate | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(caseStatus)="data">
            <b-badge :variant="$caseStatus(data.value)">
              {{ data.value | formatcaseStatus }}
            </b-badge>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-col
      cols="12"
      sm="12"
      class="d-flex align-items-center justify-content-center justify-content-sm-end">
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.totalDocs"
        :per-page="pagination.limit"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
        @change="showCurrentPage($event)"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18" />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18" />
        </template>
      </b-pagination>
    </b-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableTop from '@/components/TableTop.vue'
import TicketProvider from '@/resources/TicketProvider'
import TicketTypeProvider from '@/resources/TicketType'
import UserGroupProvider from '@/resources/UserGroupProvider'
import TicketFilter from './components/TicketFilter.vue'
// import TicketAdd from '@/components/Ticket/TicketAdd.vue'
// import TicketDetail from '@/components/Ticket/TicketDetail.vue'
const TicketTypeService = new TicketTypeProvider()
const TicketService = new TicketProvider()
const UserGroup = new UserGroupProvider()

export default {
  components: {
    TicketFilter,
    TableTop
  },
  data () {
    const {
      caseStatus,
      startDate,
      endDate
    } = this.$route.query
    return {
      isDeleteModalActive: false,
      userGroup: [],
      filter: {
        searchIncident: '',
        searchPriority: '',
        searchCustomerName: '',
        searchPhoneNumber: '',
        searchUserGroup: [],
        caseStatus: caseStatus || '',
        searchTicketId: '',
        searchSubject: '',
        startDate: startDate || '',
        endDate: endDate || ''
      },
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 10
      },
      fields: [
        { key: 'code', label: 'Case No.', sortable: true },
        { key: 'incidentType', label: 'Case Type', sortable: true },
        { key: 'subject', label: 'subject', sortable: true },
        { key: 'priority', label: 'Priority', sortable: true },
        { key: 'customerName', label: 'CustomerName', sortable: true },
        { key: 'createdAt', label: 'CreateAt', sortable: true },
        { key: 'updatedAt', label: 'UpdatedAt', sortable: true },
        { key: 'progressBy', label: 'ProgressBy', sortable: true },
        { key: 'dueDate', label: 'DueDate', sortable: true },
        { key: 'resolveDate', label: 'ResolveDate', sortable: true },
        { key: 'caseStatus', label: 'Status', sortable: true }
      ],
      items: [],
      selectedItem: {},
      initialTicketType: {},
      deleteItem: {},
      ticketType: []
    }
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      profile: 'User/user'
    })
  },
  created () {
    this.getTicket()
    this.getTicketType()
    this.getUserGroup()
  },
  methods: {
    async getTicket () {
      try {
        const data = await TicketService.paginate(this.pagination.page, this.pagination.limit, { ...this.filter, userId: this.profile.id })
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (error) {
        console.error(error)
      }
    },
    async getTicketType () {
      try {
        const { data } = await TicketTypeService.findAllType()
        this.ticketType = data
      } catch (error) {
        console.error(error)
      }
    },
    async getUserGroup () {
      try {
        const { data } = await UserGroup.findAllGroupCode()
        this.userGroup = data
      } catch (error) {
        console.error(error)
      }
    },
    rowClick (val) {
      this.selectedItem = { ...val }
      this.initialTicketType = { ...val }
      this.$router.push(`/case/detail/${val.id}`)
    },
    fetchFilter () {
      this.setPagination(1)
      this.getTicket()
    },
    showCurrentPage (page) {
      this.setPagination(page)
      this.getTicket()
    },
    setPagination (page, totalDocs) {
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs || this.pagination.totalDocs
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select {
  background: white;
}
.card-body {
  padding: 0;
}
::v-deep input.vs__search::placeholder {
  color: #B9B9C3;
}
.zoom-80 {
  zoom: 80%;
}
</style>
